import styled from 'styled-components';
import { RadioInput } from '@app/src/common/RadioInput';
import { FONTS, COLORS, SIZE } from '@app/src/ui';

interface Props {
  isDisplay?: boolean;
}

export const Description = styled.p`
  margin-left: 6px;
  font-family: ${FONTS.OPEN_SANS};
`;

export const RadioInputWrapper = styled(RadioInput)`
  display: inline-flex;
`;

export const Price = styled.span`
  font-family: ${FONTS.ROBOTO_BOLD};
  color: ${COLORS.GRAY_TEXT};
`;

export const List = styled.ul`
  margin-top: 14px;
`;

export const Item = styled.li`
  height: 22px;
  margin-bottom: 24px;
  font-family: ${FONTS.OPEN_SANS};
  font-weight: 700;
  font-size: 14px;

  ${(props: Props) => props.isDisplay ? `
    display: block;
  `:`
    display: none;
  `}

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 16px;
  }
`;

export const Title = styled.h3`
  font-family: ${FONTS.ROBOTO};
  font-size: 13px;
  margin-bottom: 9px;
  display: flex;
  align-items: center;
`;

export const IconInfo = styled.span`
  cursor: pointer;
  display: inline-block;
  height: 17px;
  margin-left: 4px;
`;

export const ModalContent = styled.p`
  width: 250px;
  margin: 50px 30px 30px;
  font-family: ${FONTS.OPEN_SANS};
  text-align: center;
`;

export const Subtitle = styled.p`
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 18px;
  color: ${COLORS.BLACK_BOLD};
  margin: 32px 0 25px 0;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 15px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
`;

export const Available = styled.span`
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.BLUE_LINK};
  font-size: 14px;
`;